"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiProfileRepRatesState } from "@/entities/IProfile";
import UserPageRepNewRepSearch from "./UserPageRepNewRepSearch";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
export default function UserPageRepNewRep(t0) {
  const $ = _c(6);
  const {
    profile,
    repRates,
    onSuccess
  } = t0;
  let t1;
  if ($[0] !== onSuccess) {
    t1 = onSuccess ? {
      onSuccess
    } : {};
    $[0] = onSuccess;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const searchProps = t1;
  let t2;
  if ($[2] !== profile || $[3] !== repRates || $[4] !== searchProps) {
    t2 = <UserPageRepNewRepSearch repRates={repRates} profile={profile} {...searchProps} />;
    $[2] = profile;
    $[3] = repRates;
    $[4] = searchProps;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}